// extracted by mini-css-extract-plugin
export default {"percent_wrapper":"PercentageInput_percent_wrapper__t5-2j","percent_input":"PercentageInput_percent_input__4UXPl","percent_icon":"PercentageInput_percent_icon__LUo0E"};